import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TitleComponent } from './components/title/title.component';
import { HeaderServiceMenuComponent } from './components/service-menu/service-menu.component';
import { AdCreateButtonComponent } from './components/ad-create-button/ad-create-button.component';
import { UserSpaceComponent } from './components/user-space/user-space.component';
import { creLinks, specTransportLinks, transportLinks } from '../../const';
import { ButtonModule } from 'primeng/button';
import { CategoryComponent } from './components/category/category.component';
import { ContentDesktopButtonTooltipDirective } from './components/tooltip/content-desktop-button-tooltip.directive';
import {ClientSideRenderingDirective} from '../../../../common/directives/client-side-rendering.directive';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'div[raHeaderDesktop]',
  standalone: true,
  imports: [
    CommonModule,
    TitleComponent,
    HeaderServiceMenuComponent,
    AdCreateButtonComponent,
    UserSpaceComponent,
    ButtonModule,
    ClientSideRenderingDirective,
    CategoryComponent,
    ContentDesktopButtonTooltipDirective,
  ],
  templateUrl: './content-desktop.component.html',
  styleUrls: ['./content-desktop.component.scss'],
})
export class ContentDesktopComponent {
  protected readonly creLinks = creLinks;
  protected readonly transportLinks = transportLinks;
  protected readonly specTransportLinks = specTransportLinks;
}
